import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';

import paginationParams from 'utils/pagination-params';

export const list = 'LIST_VQ_PROFILES';
export const single = 'SINGLE_VQ_PROFILE';

export const videoQuestionProfilesApi = createApi({
  reducerPath: 'videoQuestionProfilesApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createVideoQuestionProfile: builder.mutation({
      query: (videoQuestionProfile) => ({
        url: '/video-question-profiles/create',
        method: 'POST',
        body: videoQuestionProfile
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            videoQuestionProfilesApi.util.updateQueryData('listVideoQuestionProfiles', undefined, (draft) => {
              draft.data.items.unshift(created.data);
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateVideoQuestionProfile: builder.mutation({
      query: ({ videoQuestionProfileId, ...attributes }) => ({
        url: `/video-question-profiles/update/${videoQuestionProfileId}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ videoQuestionProfileId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            videoQuestionProfilesApi.util.updateQueryData('listVideoQuestionProfiles', undefined, (draft) => {
              const item = draft.data.items.find((profile) => profile.id === videoQuestionProfileId);
              if (item) {
                Object.assign(item, updated.data);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    deleteVideoQuestionProfile: builder.mutation({
      query: (videoQuestionProfileId) => ({
        url: `/video-question-profiles/delete/${videoQuestionProfileId}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            videoQuestionProfilesApi.util.updateQueryData('listVideoQuestionProfiles', undefined, (draft) => {
              const idx = draft.data.items.findIndex((item) => item.id === id);
              if (idx > -1) {
                draft.data.items.splice(idx, 1);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getVideoQuestionProfileById: builder.query({
      query: (videoQuestionProfileId) => `/video-question-profiles/get/${videoQuestionProfileId}`,
      providesTags: [single]
    }),
    listVideoQuestionProfiles: builder.query({
      query: (params) => ({
        url: '/video-question-profiles/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const {
  useCreateVideoQuestionProfileMutation,
  useUpdateVideoQuestionProfileMutation,
  useDeleteVideoQuestionProfileMutation,
  useGetVideoQuestionProfileByIdQuery,
  useListVideoQuestionProfilesQuery
} = videoQuestionProfilesApi;
